import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.banner,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].updateBannerStatus,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Clone',
				id: 'clone',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.banner,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].addBanners,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Deploy on App',
				id: 'deploy',
				isEnabled: (rowData: any) => {
					const { isActive } = rowData;
					if (isActive) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.banner,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner]?.deployBanner,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},

			{
				name: 'Remove from App',
				id: 'remove',
				isEnabled: (rowData: any) => {
					const { isActive } = rowData;
					if (!isActive) {
						return false;
					}

					return hasPermission({
						entity: DASHBOARD_RESOURCES.banner,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner]?.deployBanner,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Show Version History',
				id: 'versionHistory',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.banner,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].getVersionHistory,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.banner,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner]?.addBanners,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
